import { render, staticRenderFns } from "./Testimonios.vue?vue&type=template&id=51c47d5c&"
import script from "./Testimonios.vue?vue&type=script&lang=js&"
export * from "./Testimonios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports